"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import type { StockMovementRow } from "@/lib/types/product";
import { useAuthStore } from "@/stores/authStore";

export function useStockMovements(productId: number | null) {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["stock", "movements", productId],
    queryFn: async () => {
      const { data } = await api.get<{ movements: StockMovementRow[] }>(
        `/api/stock/movements/${productId}`,
      );

      return data.movements;
    },
    enabled: Boolean(token) && productId != null && productId > 0,
  });
}
